// ** Component Imports
import { Typography } from '@/shared/ui'

// ** Styled Components
import { LogoutIcon, SidebarLogout } from './styles'

// ** Action Imports
import { useLogoutMutation } from '@/entities/session/api/sessionApi'

// ** Third-party scripts
import { shutdownTawkTo } from '@/shared/lib/tawkTo'

const MODAL_DISMISSED_KEY = 'bookCallModalDismissed'

export const LogoutButton = () => {
	// ** Hooks
	const [logout] = useLogoutMutation()

	const handleLogout = async () => {
		sessionStorage.removeItem(MODAL_DISMISSED_KEY)
		
		try {
			await logout().unwrap()
			shutdownTawkTo()
		} catch (error) {
			console.error('[Logout] request failed:', error)
		}
	}

	return (
		<SidebarLogout onClick={handleLogout}>
			<LogoutIcon />
			<Typography variant='body1'>Logout</Typography>
		</SidebarLogout>
	)
}
